(function () {
  function initOne(root) {
    if (!root || root.dataset.llInit === "1") return;
    root.dataset.llInit = "1";

    // Ribbon draw
    function drawRibbon(scope) {
      const RIBBON_DURATION = 1000; // ms
      const paths = scope.querySelectorAll('.ll-ribbon-path');
      if (paths.length < 2) return;

      paths.forEach(p => {
        const len = p.getTotalLength();
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
        p.style.visibility = 'hidden';
      });

      const [top, bottom] = paths;
      requestAnimationFrame(() => {
        // Start top ribbon
        top.style.visibility = 'visible';
        top.style.transition = `stroke-dashoffset ${RIBBON_DURATION}ms ease-in-out`;
        top.style.strokeDashoffset = '0';

        // Start bottom ribbon after top finishes (timeout is more reliable than transitionend)
        setTimeout(() => {
          bottom.style.visibility = 'visible';
          bottom.style.transition = `stroke-dashoffset ${RIBBON_DURATION}ms ease-in-out`;
          bottom.style.strokeDashoffset = '0';
        }, RIBBON_DURATION);
      });
    }

    // Timed icon reveals
    function revealPointers(scope) {
      const ICON_STEP_MS = 450;
      const BASE_MS = 100;
      const LEAD_MS = 180;

      const pointers = Array.from(scope.querySelectorAll('.ll-pointer'))
        .sort((a, b) => {
          const na = +(a.className.match(/ll-p(\d)/) || [])[1] || 0;
          const nb = +(b.className.match(/ll-p(\d)/) || [])[1] || 0;
          return na - nb;
        });

      pointers.forEach((el, idx) => {
        const when = Math.max(0, BASE_MS + idx * ICON_STEP_MS - LEAD_MS);
        setTimeout(() => el.classList.add('is-in'), when);
      });
    }

    const kick = () => {
      revealPointers(root);
      drawRibbon(root);
    };

    // Trigger when scrolled into view
    try {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            kick();
            io.disconnect();
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -20% 0px' });
      io.observe(root);

      // immediate fallback
      const r = root.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) kick();
    } catch (_) {
      kick();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ll-anim-pill]').forEach(initOne);
  }

  // Run now
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Also handle Replo injecting HTML after load
  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
